import { FLOW_ROUTES } from '@withdrawals/constants'
import type { ExtendedSubFlow } from '@withdrawals/types'
import { paths } from 'mmfintech-backend-api'

export const getFlowPath = (subFlow: ExtendedSubFlow): string => {
  const flowRoute = FLOW_ROUTES.find(route => route.subFlow === subFlow)
  return `${paths.banking.send()}/${flowRoute?.pathname ?? ''}`
}
